import { ArrowUp } from "lucide-react";
import { useLang, scrollToId } from "@/lib/lang";
import { Logo } from "./Logo";

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  return (
    <footer className="border-t border-line bg-surface" data-testid="footer">
      <div className="container-x"><div className="pb-28 pt-14 sm:py-14">
        <p className="select-none font-display text-[18vw] font-semibold leading-[0.8] tracking-[-0.06em] text-ink/[0.06] lg:text-[13rem]">ExtraValue</p>
        <div className="mt-10 flex flex-col justify-between gap-10 lg:flex-row lg:items-end">
          <div>
            <Logo />
            <p className="mt-6 text-sm text-zinc-300" data-testid="footer-legal">{f.legal}</p>
            <p className="mt-2 font-mono text-xs text-zinc-400">{f.ids.join(" · ")}</p>
            <p className="mt-2 text-xs text-zinc-400">{f.seat}</p>
          </div>
          <div className="flex items-center gap-6 lg:pr-20">
            <p className="text-xs text-zinc-400">© {new Date().getFullYear()} Extra Value. {f.rights}</p>
            <button onClick={() => scrollToId("top")} className="flex items-center gap-2 rounded-full border border-line px-4 py-2 text-xs text-ink transition-colors hover:border-gold" data-testid="footer-top-btn">
              <ArrowUp size={14} /> {f.top}
            </button>
          </div>
        </div>
        </div>
      </div>
    </footer>
  );
};
